const drawerItems = [
        {
          icon: 'mdi-domain',
          title: 'Organizations',
          to: '/organizations',
        },
        {
          icon: 'mdi-account-multiple',
          title: 'Users',
          to: '/users',
        },
        {
          title: 'DigiBoards',
          icon: ' mdi-monitor-multiple',
          to: '/digi-boards',
        },
        {
          title: 'Widgets',
          icon: 'mdi-apps',
          to: '/widgets',
        },
        {
          title: 'Payments',
          icon: 'mdi-credit-card-check ',
          to: '/payments',
        },
        {
          icon: 'mdi-cog',
          title: 'Settings',
          to: '/settings',
        },
        {
          title: 'Support',
          icon: 'mdi-face-agent',
          to: '/support',
        },
    ];

export default drawerItems;
